const sortables = [
	{
		name: 'Duration',
		value: 'duration'
	},
	{
		name: 'Date',
		value: 'created_at'
	},
	{
		name: 'Views',
		value: 'num_views'
	},
	{
		name: 'Version',
		value: 'version'
	}
]

const sort_modes = {
  ASC:1,
  NONE:0,
  DESC:-1
}

export{
	sortables,
	sort_modes
}